export default __webpack_public_path__ + "static/media/skull.db35c8e0.png";